import { useTradeInCsl } from "../../csl/tradeInCslUtils";
import { useTradeInAemSelector } from "../../redux/store";
import type { DateRangeMap } from "../../utils/types";

type vehicleDetailsDateValidityReturnType = {
    selectedYear: string;
    ranges: DateRangeMap;
};

const useVehicleDetailsDateValidity = (): vehicleDetailsDateValidityReturnType | null => {
    const csl = useTradeInCsl();
    const formItems = useTradeInAemSelector((state) => state.tradeInAemVehicleDetails.formItems);

    if (!(formItems.year && formItems.month)) return null;

    const selectedYear = formItems.year.value as string;

    const ranges = csl.getFormItemDropdownRange();

    return { selectedYear, ranges };
};

export default useVehicleDetailsDateValidity;
